import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { KRAJ } from '../../kraj';

const MultiRangeSlider = ({ minPrice, maxPrice, setMinPrice, setMaxPrice, rawMinPrice, rawMaxPrice, setRawMinPrice, setRawMaxPrice, productType }) => {
  const { t } = useTranslation('lista');
  const min = 0;
  const max = productType === 'panel' ? 999 : 49999;
  const [minThumb, setMinThumb] = useState(0);
  const [maxThumb, setMaxThumb] = useState(0);

  const getPercent = useCallback(
    (value) => {
    const clampedValue = Math.min(Math.max(value, min), max);
    return ((clampedValue - min) / (max - min)) * 100;
  },
    [min, max]
  );

  const minTrigger = useCallback(() => {
    setMinThumb(getPercent(minPrice));
  }, [minPrice, getPercent]);

  const maxTrigger = useCallback(() => {
    setMaxThumb(100 - getPercent(maxPrice));
  }, [maxPrice, getPercent]);

  useEffect(() => {
    minTrigger();
    maxTrigger();
  }, [minPrice, maxPrice, minTrigger, maxTrigger]);

  useEffect(() => {
    setRawMinPrice(minPrice.toString());
  }, [minPrice, setRawMinPrice]);

  useEffect(() => {
    setRawMaxPrice(maxPrice.toString());
  }, [maxPrice, setRawMaxPrice]);

  const handleMinPriceChange = (value) => {
    if (!isNaN(value) && value >= min && value <= max && value <= maxPrice - 1) {
      setMinPrice(value);
    }
  };

  const handleMaxPriceChange = (value) => {
    if (!isNaN(value) && value >= min && value <= max && value >= minPrice + 1) {
      setMaxPrice(value);
    }
  };

  return (
    <div className="w-full px-1">
      {/* Suwak */}
      <div className="relative h-5 flex items-center">
        <input
          type="range"
          step="1"
          min={min}
          max={max}
          value={minPrice}
          onChange={(e) => handleMinPriceChange(Number(e.target.value))}
          className="absolute pointer-events-none appearance-none z-20 h-2 w-full opacity-0 cursor-pointer"
        />
        <input
          type="range"
          step="1"
          min={min}
          max={max}
          value={maxPrice}
          onChange={(e) => handleMaxPriceChange(Number(e.target.value))}
          className="absolute pointer-events-none appearance-none z-20 h-2 w-full opacity-0 cursor-pointer"
        />

        <div className="relative z-10 h-1.5 w-full">
          <div className="absolute inset-0 rounded-full bg-gray-200"></div>
          <div
            className="absolute top-0 bottom-0 rounded-full bg-blue-500"
            style={{ left: `${minThumb}%`, right: `${maxThumb}%` }}
          ></div>
          <div
            className="absolute w-4 h-4 -top-1.5 rounded-full bg-white border-2 border-blue-500 shadow-sm"
            style={{ left: `${minThumb}%`, transform: 'translateX(-50%)' }}
          ></div>
          <div
            className="absolute w-4 h-4 -top-1.5 rounded-full bg-white border-2 border-blue-500 shadow-sm"
            style={{ right: `${maxThumb}%`, transform: 'translateX(50%)' }}
          ></div>
        </div>
      </div>

      {/* Inputy od / do — spójne z inputami mocy */}
      <div className="flex justify-between items-center mt-5">
        <div className="relative">
          <input
            type="text"
            maxLength="7"
            placeholder={t('filtry.od')}
            value={rawMinPrice === "0" ? "" : rawMinPrice}
            onChange={(e) => setRawMinPrice(e.target.value)}
            className="px-3 py-2 border border-gray-200 rounded-lg w-24 text-center pr-8 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
          />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">{KRAJ.symbol}</span>
        </div>
        <span className="text-gray-400 text-xs">–</span>
        <div className="relative">
          <input
            type="text"
            maxLength="7"
            placeholder={t('filtry.do')}
            value={rawMaxPrice === (productType === 'panel' ? "999" : "49999") ? "" : rawMaxPrice}
            onChange={(e) => setRawMaxPrice(e.target.value)}
            className="px-3 py-2 border border-gray-200 rounded-lg w-24 text-center pr-8 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
          />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">{KRAJ.symbol}</span>
        </div>
      </div>
    </div>
  );
};

export default MultiRangeSlider;
